var _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutuber4527(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#ffffff",
      strokeWidth: 3,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25.931 33.796 c -0.156 0 -0.313 -0.036 -0.461 -0.113 c -1.511 -0.788 -2.98 -0.787 -4.491 0 c -0.49 0.256 -1.094 0.065 -1.349 -0.424 c -0.255 -0.49 -0.065 -1.094 0.424 -1.349 c 2.103 -1.097 4.236 -1.097 6.34 0 c 0.49 0.255 0.68 0.859 0.424 1.349 C 26.64 33.6 26.292 33.796 25.931 33.796 z",
    style: {
      stroke: "none",
      strokeWidth: 3,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 36.224 33.796 c -0.156 0 -0.313 -0.036 -0.461 -0.113 c -1.511 -0.788 -2.98 -0.789 -4.491 0 c -0.49 0.256 -1.094 0.065 -1.349 -0.424 c -0.255 -0.49 -0.065 -1.094 0.424 -1.349 c 2.104 -1.097 4.237 -1.097 6.34 0 c 0.49 0.255 0.68 0.859 0.424 1.349 C 36.934 33.6 36.585 33.796 36.224 33.796 z",
    style: {
      stroke: "none",
      strokeWidth: 3,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 28.36 48.259 c -0.003 0 -0.006 0 -0.009 0 c -2.388 -0.004 -4.74 -1.516 -6.99 -4.493 c -0.229 -0.303 -0.267 -0.709 -0.097 -1.049 c 0.169 -0.339 0.516 -0.554 0.895 -0.554 h 12.424 c 0.38 0 0.727 0.215 0.896 0.556 c 0.169 0.341 0.13 0.748 -0.1 1.05 C 33.111 46.748 30.75 48.259 28.36 48.259 z M 24.329 44.163 c 1.377 1.391 2.726 2.094 4.025 2.096 c 0.002 0 0.004 0 0.006 0 c 1.302 0 2.657 -0.703 4.043 -2.096 H 24.329 z",
    style: {
      stroke: "none",
      strokeWidth: 3,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 49.188 58.416 l -7.389 -1.244 c -2.378 -0.4 -4.104 -2.28 -4.104 -4.493 l -0.034 -1.486 c 0.112 -0.105 0.233 -0.196 0.342 -0.304 c 0.802 -0.793 1.537 -1.666 2.184 -2.593 c 0.646 -0.928 1.212 -1.92 1.681 -2.951 c 0.331 -0.728 0.598 -1.479 0.832 -2.24 c 2.838 -1.071 4.788 -3.811 4.788 -6.882 v -2.954 c 0 -1.538 -1.251 -2.789 -2.789 -2.789 h -0.664 l 0.008 -0.13 c 3.094 -4.695 4.113 -8.885 3.006 -12.452 c -1.092 -3.516 -4.246 -6.428 -9.379 -8.669 c 0.424 -0.37 1.18 -0.872 2.53 -1.492 c 0.367 -0.168 0.596 -0.541 0.582 -0.944 c -0.015 -0.403 -0.27 -0.758 -0.648 -0.9 c -8.487 -3.189 -19.279 -2.802 -24.467 5.162 c -2.819 1.049 -4.869 3.069 -5.791 5.722 c -1.321 3.797 -0.298 8.605 2.856 13.563 l 0.009 0.142 h -0.698 c -1.538 0 -2.789 1.251 -2.789 2.789 v 2.957 c 0 3.065 1.943 5.801 4.773 6.875 c 0.958 3.105 2.716 5.89 5.055 8.097 l -0.036 1.504 c 0 2.19 -1.726 4.07 -4.104 4.471 l -7.389 1.244 C 3.177 59.154 0 62.692 0 66.83 v 18.151 c 0 0.553 0.448 1 1 1 h 54.741 c 0.553 0 1 -0.447 1 -1 V 66.83 C 56.741 62.692 53.564 59.154 49.188 58.416 z M 44.699 32.479 c 0.435 0 0.789 0.354 0.789 0.789 v 2.954 c 0 1.729 -0.849 3.315 -2.184 4.311 c 0.072 -0.455 0.135 -0.913 0.174 -1.376 l 0.429 -6.678 H 44.699 z M 11.764 17.432 c 0.763 -2.192 2.45 -3.785 4.881 -4.604 c 0.221 -0.075 0.408 -0.224 0.531 -0.421 c 2.828 -4.567 7.777 -6.388 13.004 -6.388 c 2.361 0 4.779 0.372 7.083 1.03 c -1.2 0.782 -1.87 1.567 -2.07 2.405 c -0.116 0.484 0.142 0.979 0.604 1.162 c 5.216 2.064 8.359 4.714 9.34 7.875 c 0.704 2.267 0.33 4.914 -1.111 7.896 c -0.142 -1.048 -0.452 -1.832 -1.023 -2.336 c -0.343 -0.302 -0.931 -0.625 -1.779 -0.469 c -3.222 0.503 -6.786 0.746 -10.979 -0.859 c -4.436 -1.857 -9.998 -3.693 -13.669 -1.405 c -1.75 1.092 -2.898 2.953 -3.473 5.651 C 11.322 23.399 10.843 20.08 11.764 17.432 z M 11.254 36.225 v -2.957 c 0 -0.435 0.354 -0.789 0.789 -0.789 h 0.818 l 0.405 6.698 c 0.038 0.454 0.093 0.904 0.163 1.35 C 12.099 39.531 11.254 37.949 11.254 36.225 z M 15.261 39.033 l -0.544 -8.987 c 0.221 -3.594 1.201 -5.961 2.917 -7.031 c 2.927 -1.825 8.159 0.012 11.868 1.564 c 4.672 1.788 8.705 1.499 12.062 0.974 c 0.073 -0.014 0.106 -0.008 0.109 -0.008 c 0 0 0 0 0 0 c 0.148 0.087 0.611 0.663 0.39 4.426 c 0 0 0 0.001 0 0.001 l -0.581 9.039 c -0.16 1.912 -0.643 3.764 -1.435 5.506 c -0.419 0.92 -0.924 1.807 -1.501 2.635 c -0.577 0.828 -1.233 1.607 -1.95 2.315 c -1.729 1.711 -3.766 2.998 -6.056 3.824 c -1.399 0.505 -2.941 0.507 -4.34 0 C 20.095 51.085 15.8 45.479 15.261 39.033 z M 21.042 52.811 c 1.362 0.973 2.861 1.777 4.478 2.361 c 0.919 0.332 1.885 0.499 2.851 0.499 c 0.966 0 1.931 -0.166 2.85 -0.499 c 1.615 -0.583 3.104 -1.393 4.479 -2.376 c 0.033 2.141 1.169 4.064 2.946 5.242 c -6.891 6.214 -13.635 6.213 -20.548 -0.001 C 19.876 56.859 21.012 54.939 21.042 52.811 z M 7.886 60.389 l 7.389 -1.244 c 0.294 -0.05 0.579 -0.121 0.858 -0.203 c 4.068 3.861 8.159 5.811 12.248 5.811 c 4.088 0 8.174 -1.95 12.23 -5.81 c 0.279 0.082 0.563 0.153 0.857 0.203 l 7.389 1.244 c 3.41 0.575 5.886 3.284 5.886 6.441 v 6.331 h -5.787 c -1.512 0 -2.971 0.593 -4.002 1.626 c -0.952 0.952 -1.475 2.196 -1.473 3.503 c 0.004 2.898 0.004 4.703 0.001 5.691 H 13.205 c -0.003 -0.892 -0.003 -2.569 0.001 -5.692 c 0.001 -1.306 -0.521 -2.55 -1.473 -3.503 c -1.032 -1.032 -2.49 -1.625 -4.002 -1.625 H 2 V 66.83 C 2 63.673 4.476 60.964 7.886 60.389 z M 2 75.161 h 5.73 c 0.985 0 1.928 0.379 2.587 1.039 c 0.574 0.574 0.889 1.315 0.888 2.087 c -0.004 3.122 -0.003 4.791 -0.001 5.694 H 2 V 75.161 z M 45.479 83.981 c 0.004 -1.327 0.002 -3.663 -0.001 -5.694 c -0.001 -0.771 0.314 -1.513 0.889 -2.087 c 0.659 -0.66 1.602 -1.039 2.587 -1.039 h 5.787 v 8.82 H 45.479 z",
    style: {
      stroke: "none",
      strokeWidth: 3,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 59.376 46.8 c -0.144 0 -0.288 -0.031 -0.423 -0.095 c -0.353 -0.164 -0.577 -0.518 -0.577 -0.906 v -7.796 h -2.46 c -2.395 0 -4.343 -1.949 -4.343 -4.344 V 8.362 c 0 -2.395 1.948 -4.344 4.343 -4.344 h 29.74 C 88.052 4.018 90 5.967 90 8.362 V 33.66 c 0 2.395 -1.948 4.344 -4.344 4.344 H 70.25 l -10.232 8.563 C 59.834 46.72 59.606 46.8 59.376 46.8 z M 55.916 6.018 c -1.292 0 -2.343 1.051 -2.343 2.344 V 33.66 c 0 1.292 1.051 2.344 2.343 2.344 h 3.46 c 0.553 0 1 0.448 1 1 v 6.655 l 8.869 -7.422 c 0.18 -0.15 0.407 -0.233 0.642 -0.233 h 15.77 c 1.292 0 2.344 -1.051 2.344 -2.344 V 8.362 c 0 -1.292 -1.052 -2.344 -2.344 -2.344 H 55.916 z",
    style: {
      stroke: "none",
      strokeWidth: 3,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 77.358 25.764 c -0.175 0 -0.316 -0.142 -0.316 -0.316 v -4.812 c 0 -3.184 -2.294 -5.885 -5.256 -6.386 v -1.561 c 0 -0.552 -0.447 -1 -1 -1 s -1 0.448 -1 1 v 1.551 c -1.264 0.199 -2.419 0.777 -3.355 1.686 c -1.225 1.189 -1.899 2.783 -1.899 4.49 v 5.032 c 0 0.174 -0.142 0.316 -0.316 0.316 c -0.553 0 -1 0.448 -1 1 s 0.447 1 1 1 h 3.043 c 0.035 1.919 1.602 3.471 3.529 3.471 c 1.928 0 3.494 -1.552 3.53 -3.471 h 3.043 c 0.553 0 1 -0.448 1 -1 S 77.911 25.764 77.358 25.764 z M 70.786 29.235 c -0.825 0 -1.494 -0.655 -1.529 -1.471 h 3.058 C 72.281 28.58 71.611 29.235 70.786 29.235 z M 66.51 25.764 c 0.014 -0.104 0.021 -0.209 0.021 -0.316 v -5.032 c 0 -1.161 0.459 -2.246 1.292 -3.054 c 0.833 -0.808 1.93 -1.246 3.095 -1.199 c 2.274 0.068 4.124 2.075 4.124 4.474 v 4.812 c 0 0.107 0.008 0.213 0.021 0.316 H 66.51 z",
    style: {
      stroke: "none",
      strokeWidth: 3,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 61.669 21.292 c -0.553 0 -1 -0.448 -1 -1 c 0 -2.133 0.662 -4.169 1.915 -5.889 c 0.326 -0.447 0.951 -0.543 1.397 -0.219 c 0.446 0.325 0.545 0.951 0.22 1.397 c -1.003 1.375 -1.532 3.004 -1.532 4.711 C 62.669 20.844 62.222 21.292 61.669 21.292 z",
    style: {
      stroke: "none",
      strokeWidth: 3,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 57.6 21.152 c -0.553 0 -1 -0.448 -1 -1 c 0 -3.034 0.95 -5.924 2.748 -8.357 c 0.328 -0.444 0.952 -0.539 1.399 -0.21 c 0.443 0.328 0.538 0.954 0.21 1.398 c -1.542 2.087 -2.357 4.566 -2.357 7.169 C 58.6 20.705 58.152 21.152 57.6 21.152 z",
    style: {
      stroke: "none",
      strokeWidth: 3,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 79.904 21.292 c -0.553 0 -1 -0.448 -1 -1 c 0 -1.707 -0.529 -3.336 -1.532 -4.711 c -0.325 -0.446 -0.227 -1.072 0.22 -1.397 c 0.446 -0.324 1.071 -0.228 1.397 0.219 c 1.253 1.719 1.915 3.755 1.915 5.889 C 80.904 20.844 80.457 21.292 79.904 21.292 z",
    style: {
      stroke: "none",
      strokeWidth: 3,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 83.974 21.152 c -0.553 0 -1 -0.448 -1 -1 c 0 -2.603 -0.815 -5.082 -2.357 -7.169 c -0.328 -0.444 -0.233 -1.07 0.21 -1.398 c 0.446 -0.329 1.071 -0.234 1.399 0.21 c 1.798 2.433 2.748 5.323 2.748 8.357 C 84.974 20.705 84.526 21.152 83.974 21.152 z",
    style: {
      stroke: "none",
      strokeWidth: 3,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutuber4527);
export default __webpack_public_path__ + "static/media/youtuber-4527.0501f6b8aa437304ae07cbe490dc9943.svg";
export { ForwardRef as ReactComponent };